import { Stack } from "@mui/material";
import { reasonsForStopUsingList } from "../data";
import { CheckboxItem } from "./CheckboxItem";
import { useContext } from "react";
import { FeedbackContext } from "../context";
import { OtherCustomInput } from "./OtherCustomInput";

export const SelectReasonForNotUsing = () => {
  const context = useContext(FeedbackContext);
  if (!context) throw new Error("wrong context provided");
  const {
    notUsingReasons,
    toggleNotUsingReason,
    toggleOtherNotUsingReason,
    toolSwitchedTo,
  } = context;

  const isOtherSelected = notUsingReasons.some((item) =>
    item.value.startsWith("other_"),
  );

  return (
    <Stack gap="16px">
      <Stack gap="12px">
        {reasonsForStopUsingList.map((reason) => {
          const isChecked = notUsingReasons.some(
            (item) => item.value === reason.value,
          );
          return reason?.value === "switched-to-another-tool" ? (
            <OtherCustomInput
              key={reason.value}
              isSelected={isChecked}
              customReasonLabel={reason.label}
              customReasonId={reason.value}
              onClick={() => {
                toggleNotUsingReason({
                  label: reason.label,
                  value: reason.value,
                });
              }}
              customRows={1}
              placeholder={"Enter tool's name"}
            />
          ) : (
            <CheckboxItem
              key={reason.value}
              label={reason.label}
              isChecked={isChecked}
              onClick={() =>
                toggleNotUsingReason({
                  label: reason.label,
                  value: reason.value,
                })
              }
            />
          );
        })}
        <OtherCustomInput
          key="other"
          isSelected={isOtherSelected}
          onClick={toggleOtherNotUsingReason}
          placeholder="Tell us why you're leaving"
        />
      </Stack>
    </Stack>
  );
};
